<template>
  <a :href="activityLink" target="_blank" class="row m-n block">
    <div v-if="image" class="col-md-4 no-padder">
      <div style="height:180px; overflow: hidden;">
        <div :style="imageStyle"></div>
      </div>
    </div>

    <div class="col-md-8">
      <span v-if="object.comment" class="clear">
        <span class="block m-b-sm">{{ object.comment }}</span>
      </span>
      <span v-else-if="activity.object" class="clear">
        <span class="block m-b-sm commented-title">{{ activity.object.title }}</span>
        <small class="block commented-description">{{ activity.object.description }}</small>
      </span>
      <div v-else class="clear">
        <span class="block m-b-sm commented-title">{{ activity.content.title }}</span>
        <small class="block commented-description">{{ activity.content.description }}</small>
      </div>
    </div>
  </a>
</template>

<script>
import moment from 'moment-timezone'
import urlParser from 'js-video-url-parser'
import { loadImage } from '@src/helpers/image-helper'
import shave from 'shave'

export default {
  name: 'media',
  props: ['activity'],
  isOwner: null,
  media: null,
  data() {
    return {
      mediaFile: `${window.user.community_url}/uploads/system/default/media/`,
      image: null,
      video: null,
      typeImage: 'image',
      typeVideo: 'video',
      typeDoc: 'doc',
      activityLink: '',
      slug: ''
    }
  },
  mounted() {
    this.defineLink()
    this.getImage()
  },
  computed: {
    object() {
      return this.activity.object ? this.activity.object : this.activity.content
    },
    imageStyle() {
      return {
        'background-image': 'url(' + this.image + ')',
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        height: '100%'
      }
    }
  },
  methods: {
    getImage() {
      if (this.object.type == this.typeDoc) {
        switch (this.object.extension) {
          case 'xls':
            this.image = this.mediaFile + 'xls.jpg'
            break
          case 'xlsx':
            this.image = this.mediaFile + 'xlsx.jpg'
            break
          case 'ppt':
            this.image = this.mediaFile + 'ppt.jpg'
            break
          case 'pptx':
            this.image = this.mediaFile + 'pptx.jpg'
            break
          case 'pdf':
            this.image = this.mediaFile + 'pdf.jpg'
            break
          default:
            this.image = this.mediaFile + 'doc.jpg'
        }
      } else if (this.object.type == this.typeImage) {
        this.image =
          this.activity.object && this.activity.object.url
            ? this.activity.object.url
            : this.activity.content.avatar
      } else if (this.object.type == this.typeVideo) {
        this.video = urlParser.parse(this.object.url)
        loadImage(
          `https://img.youtube.com/vi/${this.video.id}/hqdefault.jpg`,
          `https://img.youtube.com/vi/default/default.jpg`,
          null,
          src => (this.image = src)
        )
      } else {
        // @TODO
        this.image = `${process.env.AWS_URL}/system/blog_default.jpg`
      }
    },
    defineLink() {
      const baseLink = `${window.user.community_url}/${window.user.community_domain}/default/`
      const slug = this.object.slug ? this.object.slug : this.object.alias

      if (this.activity.object) {
        switch (this.activity.action_name) {
          case 'post_create':
          case 'post_update':
          case 'post_like':
          case 'post_comment':
          case 'post_comment_like':
            this.activityLink = baseLink + `post/view/${slug}`
            break
          case 'media':
            this.activityLink =
              baseLink + `corporate#/view/${this.activity.owner.id}/media`
            break
          case 'event_create':
          case 'event_join':
          case 'event_update':
          case 'event_like':
          case 'event_comment':
          case 'event_comment_like':
            this.activityLink = baseLink + `events/view/${slug}`
            break
          case 'wall':
            this.activityLink =
              this.object.type == 'article' ? this.object.url : '#'
            break
          default:
            this.activityLink = '#'
            break
        }
      } else {
        switch (this.activity.content_type) {
          case 'post':
            this.activityLink = baseLink + `post/view/${slug}`
            break
          case 'event':
            this.activityLink = baseLink + `events/view/${slug}`
            break
          case 'groups':
            this.activityLink = baseLink + `groups/view/${slug}`
            break
          case 'blog':
            this.activityLink = baseLink + `blog/view/${slug}`
            break
          case 'profile':
            this.activityLink = baseLink + `profiles/view/${slug}`
            break
          default:
            this.activityLink = '#'
            break
        }
      }
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 1200px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 1024px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 1023px) and (min-width: 768px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 767px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>


